import React from 'react';
import PropTypes from 'prop-types';
import { FiChevronsLeft, FiChevronsRight } from 'react-icons/fi';
import { Button } from 'components';
const Pagination = ({ prevHandler, nextHandler, isFirstPage, hasMorePage }) => {
  return (
    <ul className="lf-pagination">
      <Button primary className="mr-1x" disabled={isFirstPage} clickHandler={prevHandler}>
        <FiChevronsLeft size={22} />
      </Button>
      <Button primary disabled={!hasMorePage} clickHandler={nextHandler}>
        <FiChevronsRight size={22} />
      </Button>
    </ul>
  );
};

Pagination.propTypes = {
  prevHandler: PropTypes.func,
  nextHandler: PropTypes.func,
  isFirstPage: PropTypes.bool,
  hasMorePage: PropTypes.bool,
};

Pagination.defaultProps = {
  prevHandler: () => {},
  nextHandler: () => {},
  isFirstPage: false,
  hasMorePage: false,
};

export default Pagination;
